import api from "api";
import { useMutation } from "react-query";
import { z } from "zod";

export const ClinicPartnerPayloadSchema = z.object({
  email: z.string().email("errors.invalid_email").min(1, "errors.required"),
  first_name: z.string().min(1, "errors.required"),
  last_name: z.string().min(1, "errors.required"),
  us_provider_group_clinic_ids: z.array(z.number()).min(1, "errors.required"),
});
export type ClinicPartnerPayload = z.infer<typeof ClinicPartnerPayloadSchema>;

const OP = "POST /invitations/clinic_partner";

const useInvitePartner = () =>
  useMutation((data: ClinicPartnerPayload) => {
    // @ts-ignore
    return api.parse(OP, { data });
  });

export default useInvitePartner;
